import StageOrientation from './StageOrientation';
import Donut from './seatIcons/Donut';
import Circle from './seatIcons/Circle';
import Wheelchair from './seatIcons/Wheelchair';
import Star from './seatIcons/Star';
import EmptySet from './seatIcons/EmptySet';

function makeSeatElement(seat, unitSize) {
  return `
    <g>
      <use role="button" tabindex="0" xlink:href="#tn-syos-seat-map-icon-${seat.iconType}" data-tn-seat-id="${seat.id}" class="tn-syos-seat-map__seat" x="${seat.x}" y="${seat.y}" width="${unitSize}" height="${unitSize}"/>
    </g>
  `;
}

function makeNonSeatHtml(nonSeat) {
  return `<div class="tn-syos-seat-map__non-seat" style="top: ${nonSeat.y}px; left: ${nonSeat.x}px;">${nonSeat.letter}</div>`;
}

function makeNonSeatsHtml(nonSeats) {
  return `
    <div class="tn-syos-seat-map__non-seats">
      ${nonSeats.map(makeNonSeatHtml).join('')}
    </div>
  `;
}

function makeStageIndicatorHtml(stageOrientation) {
  if (stageOrientation === StageOrientation.NONE) {
    return '';
  }

  return `
    <div class="tn-syos-seat-map__stage-indicator tn-syos-seat-map__stage-indicator--${stageOrientation}">
      <div class="tn-syos-seat-map__stage-indicator-label">STAGE</div>
    </div>
  `;
}

function makeSeatMapSvg(unitSize, marginSize, seats, width, height) {
  const seatsSvg = seats.map(seat => makeSeatElement(seat, unitSize)).join('');

  const SYMBOL_MARKUP = [
    Donut.SYMBOL_MARKUP,
    Circle.SYMBOL_MARKUP,
    Wheelchair.SYMBOL_MARKUP,
    Star.SYMBOL_MARKUP,
    EmptySet.SYMBOL_MARKUP,
  ].join('');

  return `
    <svg class="tn-syos-seat-map__svg" xmlns='http://www.w3.org/2000/svg' xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 ${width} ${height}" width="${width}px" height="${height}px">
      ${SYMBOL_MARKUP}
      ${seatsSvg}
    </svg>
  `;
}

class SyosSeatMap {
  constructor({
    unitSize,
    marginSize,
    seats,
    nonSeats,
    rowCount,
    columnCount,
    stageOrientation,
  }) {
    this.width = (unitSize * columnCount) + (marginSize * (columnCount - 1));
    this.height = (unitSize * rowCount) + (marginSize * (rowCount - 1));

    this.makeEl(
      unitSize,
      marginSize,
      seats,
      nonSeats,
      rowCount,
      columnCount,
      stageOrientation,
    );
  }

  makeEl(
    unitSize,
    marginSize,
    seats,
    nonSeats,
    rowCount,
    columnCount,
    stageOrientation,
  ) {
    const { width, height } = this;
    const seatMapSvg = makeSeatMapSvg(unitSize, marginSize, seats, width, height);
    const nonSeatsHtml = makeNonSeatsHtml(nonSeats);
    const stageIndicatorHtml = makeStageIndicatorHtml(stageOrientation);

    const el = document.createElement('div');
    el.classList.add('tn-syos-seat-map');
    el.style.width = `${width}px`;
    el.style.height = `${height}px`;

    el.innerHTML = seatMapSvg + nonSeatsHtml + stageIndicatorHtml;

    this.el = el;
  }

  getWidth() {
    return this.width;
  }

  getHeight() {
    return this.height;
  }

  destroy() {
    const { el } = this;
    el.parentNode.removeChild(el);
  }

  getEl() {
    return this.el;
  }
}

export default SyosSeatMap;



// WEBPACK FOOTER //
// ./src/syos/SyosSeatMap.js